import React from "react";
import { connect } from "react-redux";

import {
  // BrowserRouter as Router,
  HashRouter as Router,
  Route,
  Redirect
} from "react-router-dom";
import Home from "screens/Home";
import Kiosk from "screens/Kiosk";
import Contact from "screens/Contact";
import Footer from "components/Footer";
import Header from "components/Header";

import axios from "axios";
import { setKiosk } from "store/actions/appConfig";
import SignIn from "screens/SignIn";
import ResettingRequest from "screens/ResettingRequest";
import SignUp from "screens/SignUp";
import ResetPassword from "screens/ResetPassword";
import ConfirmRegistration from "screens/ConfirmRegistration";
import API from "api";
import moment from "moment";
import Profile from "screens/Profile";

const WrapperRouter = ({
  component: Component,
  showHeader,
  showFooter,
  ...rest
}) => (
  <Route
    render={props => (
      <React.Fragment>
        {showHeader && <Header {...props} />}
        <Component {...props} />
        {showFooter && <Footer {...props} />}
      </React.Fragment>
    )}
    {...rest}
  />
);

WrapperRouter.defaultProps = {
  showHeader: true,
  showFooter: true
};

function PrivateRoute({ isAuth, redirectPath, ...rest }) {
  if (isAuth) {
    return <WrapperRouter {...rest} />;
  }

  return (
    <WrapperRouter
      {...rest}
      render={props => (
        <Redirect
          to={{
            pathname: redirectPath || "/",
            state: { from: props.location }
          }}
        />
      )}
    />
  );
}

class EntryApp extends React.Component {
  constructor(props) {
    super(props);

    if (props.isAuth) {
      axios.defaults.headers.common["Authorization"] = props.user.api_key;
    } else {
      axios.defaults.headers.common["Authorization"] =
        process.env.REACT_APP_API_SECRETE;
    }
    API.getKiosk(process.env.REACT_APP_API_SECRETE).then(res => {
      res.data.expiresAt = moment()
        .add(2, "hours")
        .toISOString();

      this.props.setKiosk(res.data);
    });
  }

  render() {
    return (
      <Router>
        <WrapperRouter
          exact
          path="/"
          component={Home}
          showFooter={false}
          showHeader={false}
        />

        <WrapperRouter path="/publications" component={Kiosk} />
        <WrapperRouter path="/contact" component={Contact} />

        <WrapperRouter
          path="/signin"
          component={SignIn}
          showFooter={false}
          showHeader={false}
        />
        <WrapperRouter
          path="/login"
          component={SignIn}
          showFooter={false}
          showHeader={false}
        />
        <WrapperRouter
          path="/signup"
          component={SignUp}
          showFooter={false}
          showHeader={false}
        />
        <WrapperRouter
          path="/resetting/request"
          component={ResettingRequest}
          showFooter={false}
          showHeader={false}
        />
        <WrapperRouter
          path="/resetting/reset/:token"
          component={ResetPassword}
          showFooter={false}
          showHeader={false}
        />
        <WrapperRouter
          path="/registration/confirm/:token"
          component={ConfirmRegistration}
          showFooter={false}
          showHeader={false}
        />
        <PrivateRoute
          path="/profile"
          redirectPath="/signin"
          component={Profile}
          isAuth={true}
        />
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  apiKey: state.security.user ? state.security.user.api_key || state.security.user.apiKey  : null,
  kiosk: state.app.kiosk,
  user: state.security.user || null,
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({
  setKiosk: kiosk => dispatch(setKiosk(kiosk))
});
export default connect(mapStateToProps, binActionsToProps)(EntryApp);
